import { useBoard } from "../../../providers/BoardDetailProvider";
import SnackbarMessage from "../../atoms/Snackbar";

const CommentSnackbar = () => {
  const {
    state: { snackbar },
    updateSnackbar,
  } = useBoard();
  const handleToggleSnackbar = () => {
    updateSnackbar({ message: "", severity: "success" });
  };
  return (
    <SnackbarMessage
      message={snackbar.message}
      severity={snackbar.severity || "success"}
      open={!!snackbar.message}
      handleClose={handleToggleSnackbar}
    />
  );
};

export default CommentSnackbar;
